// D:\Sanad-Ins\sanad-ins\src\pages\HomePage.js
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import StoryScene from '../components/StoryScene/StoryScene';
import InsuranceCard from '../components/InsuranceCard/InsuranceCard';
import LoginModal from '../components/LoginModal/LoginModal';
import './HomePage.css';

const HomePage = () => {
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [butterflies, setButterflies] = useState([]);
  const navigate = useNavigate();
  
  const { currentLanguage } = useSelector((state) => state.language);
  const { isAuthenticated } = useSelector((state) => state.auth);
  
  // البيانات الأساسية
  const insuranceTypes = [
    { 
      title: {
        en: 'Compulsory Car Insurance',
        ar: 'تأمين المركبات الإجباري'
      },
      category: 'vehicles'
    },
    { 
      title: {
        en: 'Comprehensive Car Insurance',
        ar: 'تأمين المركبات الشامل'
      },
      category: 'vehicles'
    },
    { 
      title: {
        en: 'Travelers Insurance',
        ar: 'تأمين المسافرين'
      },
      category: 'persons'
    },
    { 
      title: {
        en: 'Aviation Insurance',
        ar: 'تأمين الطيران'
      },
      category: 'aviation'
    },
    { 
      title: {
        en: 'Fire & Theft Insurance',
        ar: 'تأمين الحريق والسطو'
      },
      category: 'property'
    },
    { 
      title: {
        en: 'Energy Insurance',
        ar: 'تأمين الطاقة'
      },
      category: 'energy'
    },
    { 
      title: {
        en: 'Engineering Insurance',
        ar: 'التأمين الهندسي'
      },
      category: 'engineering'
    },
    { 
      title: {
        en: 'Personal Accident Insurance',
        ar: 'تأمين الحوادث الشخصية'
      },
      category: 'persons'
    },
    { 
      title: {
        en: 'Medical Insurance',
        ar: 'التأمين الصحي'
      },
      category: 'health'
    },
    { 
      title: {
        en: 'Social Takaful Insurance',
        ar: 'التأمين التكافلي الاجتماعي'
      },
      category: 'takaful'
    },
    { 
      title: {
        en: 'Civil Liability Insurance',
        ar: 'تأمين المسؤولية المدنية'
      },
      category: 'liability'
    },
    { 
      title: {
        en: 'Cyber Risks Insurance',
        ar: 'تأمين الأخطار السيبرانية'
      },
      category: 'cyber'
    },
    { 
      title: {
        en: 'War Risks Insurance',
        ar: 'تأمين أخطار الحروب'
      },
      category: 'war'
    }
  ];
  
  useEffect(() => {
    // إنشاء الفراشات المتحركة
    const newButterflies = Array.from({ length: 8 }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: Math.random() * 5,
      size: Math.random() * 20 + 20,
    }));
    setButterflies(newButterflies);
  }, []);
  
  const renderButterflies = () => {
    return butterflies.map((butterfly) => (
      <motion.div
        key={butterfly.id}
        className="butterfly"
        style={{
          left: `${butterfly.x}%`,
          top: `${butterfly.y}%`,
          width: `${butterfly.size}px`,
          height: `${butterfly.size}px`,
        }}
        animate={{
          x: [0, 50, 0],
          y: [0, -50, 0],
          rotate: [0, 180, 360],
        }}
        transition={{
          duration: 15 + butterfly.delay,
          repeat: Infinity,
          ease: "linear",
        }}
      />
    ));
  };
  
  const handleServiceClick = (service) => {
    // حفظ نوع التأمين المحدد
    localStorage.setItem('selectedService', JSON.stringify({
      title: service.title[currentLanguage],
      category: service.category
    }));
    
    // الانتقال إلى صفحة الخدمات
    navigate('/services');
  };
  
  const handleViewServices = () => {
    navigate('/services');
  };
   const handleViewContact = () => {
    navigate('/Contact');
  };
  return (
    <div className={`home-page ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
      {/* خلفية متحركة */}
      <div className="animated-bg" />
      
      {/* الفراشات المتحركة */}
      {renderButterflies()}
      
      {/* الهيدر */}
      <Header />
      
      {/* المشهد الأول: البداية */}
      <StoryScene 
        sceneId="home"
        background="linear-gradient(135deg, rgba(36, 8, 60, 0.95) 0%, rgba(112, 72, 156, 0.85) 100%)"
        particles={20}
      >
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="hero-content"
        >
          <h1 className="scene-title breathing">
            {currentLanguage === 'en' 
              ? 'In a world full of surprises…' 
              : 'في عالم مليان مفاجآت…'}
          </h1>
          <p className="scene-subtitle fade-in" style={{ animationDelay: '0.5s' }}>
            {currentLanguage === 'en' 
              ? 'Peace of mind is not a luxury' 
              : 'الاطمئنان مش رفاهية'}
          </p>
          <div className="hero-buttons">
            <motion.button 
              className="cta-button pulse-soft"
              onClick={handleViewContact}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {isAuthenticated 
                ? (currentLanguage === 'en' ? 'Go to Dashboard' : 'الذهاب للوحة التحكم')
                : (currentLanguage === 'en' ? 'Start Your Journey' : 'ابدأ رحلتك معنا')}
            </motion.button>
            <motion.button 
              className="view-services-btn"
              onClick={handleViewServices}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {currentLanguage === 'en' ? 'Explore Our Services' : 'اكتشف خدماتنا'}
            </motion.button>
          </div>
        </motion.div>
      </StoryScene>
      
      {/* المشهد الثاني: القلق اليومي */}
      <StoryScene 
        sceneId="services"
        background="linear-gradient(135deg, rgba(112, 72, 156, 0.9) 0%, rgba(172, 19, 227, 0.74) 100%)"
        particles={15}
      >
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="scene-title">
            {currentLanguage === 'en' 
              ? 'Daily worries that need protection' 
              : 'مخاطر يومية تحتاج للحماية'}
          </h2>
          <div className="worry-items">
            <motion.div 
              className="worry-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <span className="worry-icon">🚗</span>
              <p>{currentLanguage === 'en' ? 'A simple accident' : 'حادث بسيط'}</p>
            </motion.div>
            <motion.div 
              className="worry-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <span className="worry-icon">✈️</span>
              <p>{currentLanguage === 'en' ? 'An unexpected journey' : 'رحلة غير متوقعة'}</p>
            </motion.div>
            <motion.div 
              className="worry-item"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <span className="worry-icon">🏠</span>
              <p>{currentLanguage === 'en' ? 'A decision needing security' : 'قرار يحتاج أمان'}</p>
            </motion.div>
          </div>
        </motion.div>
      </StoryScene>
       {/* المشهد الثالث : سند */}
<motion.div
  initial={{ scale: 0 }}
  whileInView={{ scale: 1 }}
  transition={{ type: "spring", stiffness: 100, damping: 10 }}
  viewport={{ once: true }}
  className="sanad-reveal"
>
    <motion.p 
    className="reveal-text"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 1, delay: 0.8 }}
    viewport={{ once: true }}
  >
    {currentLanguage === 'en' 
      ? 'And here… there is support' 
      : 'وهنا… يكون السند'}
  </motion.p>
   <div className="sanad-logo">
    <motion.img
      src="/images/Sandlogo.png"
      alt="سند للتأمين - SANAD Insurance"
      className="logo-image-reveal"
      initial={{ opacity: 0, rotate: -180 }}
      whileInView={{ opacity: 1, rotate: 0 }}
      transition={{ duration: 1, delay: 0.2 }}
      viewport={{ once: true }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%2370489C' rx='20'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' font-family='Arial' font-size='24' fill='white' font-weight='bold'%3Eسند%3C/text%3E%3C/svg%3E";
      }}
    />
    <motion.div
      className="logo-text-container"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      viewport={{ once: true }}
    >
      {/* <h2 className="logo-text">سند للتأمين</h2>
      <p className="logo-sub">SANAD Insurance</p> */}
    </motion.div>
  </div>

</motion.div>
    
      {/* المشهد الرابع: الخدمات */}
      <StoryScene 
        sceneId="services-showcase"
        background="linear-gradient(135deg, rgba(112, 72, 156, 0.9) 0%, rgba(172, 19, 227, 0.74) 100%)"
      >
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="scene-title">
            {currentLanguage === 'en' 
              ? 'What We Offer' 
              : 'ماذا نقدم؟'}
          </h2>
          <p className="scene-subtitle">
            {currentLanguage === 'en' 
              ? 'Because safety should be simple' 
              : 'لأن الأمان لازم يكون بسيط'}
          </p>
          <div className="insurance-grid">
            {insuranceTypes.map((insurance, index) => (
              <motion.div 
                key={index}
                className="insurance-card-wrapper"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ y: -10 }}
              >
                <div className="insurance-card">
                  <div className="card-icon">
                    <motion.span
                      animate={{ rotate: [0, 10, 0] }}
                      transition={{ duration: 2, repeat: Infinity }}
                    >
                      {(() => {
                        // إرجاع الأيقونة المناسبة حسب النوع
                        const icons = {
                          'vehicles': '🚗',
                          'persons': '👤',
                          'aviation': '✈️',
                          'property': '🏠',
                          'energy': '⚡',
                          'engineering': '🏗️',
                          'health': '🏥',
                          'takaful': '🕌',
                          'liability': '⚖️',
                          'cyber': '💻',
                          'war': '⚠️'
                        };
                        return icons[insurance.category] || '🛡️';
                      })()}
                    </motion.span>
                  </div>
                  <h3 className="card-title">{insurance.title[currentLanguage]}</h3>
                  <p className="card-description">
                    {currentLanguage === 'en' 
                      ? 'Comprehensive protection for your needs'
                      : 'حماية شاملة لاحتياجاتك'}
                  </p>
                  <motion.button 
                    className="card-button"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => handleServiceClick(insurance)}
                  >
                    {currentLanguage === 'en' ? 'Learn More' : 'تعرف أكثر'}
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </StoryScene>
      
      {/* المشهد الخامس: الفلسفة */}
      <StoryScene 
        sceneId="philosophy"
        background="linear-gradient(135deg, rgba(255, 159, 67, 0.9) 0%, rgba(250, 82, 82, 0.8) 100%)"
      >
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="philosophy-content"
        >
          <h2 className="scene-title breathing">
            {currentLanguage === 'en' 
              ? 'At Sanad' 
              : 'في سند'}
          </h2>
          <motion.p 
            className="philosophy-text"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            {currentLanguage === 'en' 
              ? 'We don\'t sell policies, we provide peace of mind' 
              : 'ما نبيعوش في وثيقة، نقدموا في راحة البال'}
          </motion.p>
          <div className="breathing-circle"></div>
        </motion.div>
      </StoryScene>
      
      {/* المشهد السادس: الثقة */}
      <StoryScene 
        sceneId="trust"
        background="linear-gradient(135deg, rgba(129, 24, 156, 0.9) 0%, rgba(112, 72, 156, 0.8) 100%)"
      >
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <h2 className="scene-title">
            {currentLanguage === 'en' 
              ? 'Trust Built on Clear Service' 
              : 'ثقة تبنى على خدمة واضحة'}
          </h2>
          <div className="trust-stats">
            <motion.div 
              className="stat-item"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <h3 className="stat-number">+15K</h3>
              <p className="stat-label">
                {currentLanguage === 'en' ? 'Protected Clients' : 'عميل محمي'}
              </p>
            </motion.div>
            <motion.div 
              className="stat-item"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h3 className="stat-number">24/7</h3>
              <p className="stat-label">
                {currentLanguage === 'en' ? 'Support Available' : 'دعم متاح'}
              </p>
            </motion.div>
            <motion.div 
              className="stat-item"
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
              viewport={{ once: true }}
            >
              <h3 className="stat-number">13</h3>
              <p className="stat-label">
                {currentLanguage === 'en' ? 'Insurance Types' : 'نوع تأمين'}
              </p>
            </motion.div>
          </div>
          <p className="trust-text">
            {currentLanguage === 'en' 
              ? '(No exaggeration, no big promises)' 
              : '(بدون مبالغة، بدون وعود كبيرة)'}
          </p>
        </motion.div>
      </StoryScene>
      
      {/* المشهد الأخير: الدعوة */}
      <StoryScene 
        sceneId="contact"
        background="linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)"
      >
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="invitation-content"
        >
          <h2 className="scene-title" style={{ color: 'var(--primary-color)' }}>
            {currentLanguage === 'en' 
              ? 'Be at peace, Sanad is with you' 
              : 'خليك مطمئن، وسند معاك'}
          </h2>
          <div className="invitation-buttons">
            <motion.button 
              className="final-cta-button"
              onClick={handleViewContact}
              whileHover={{ scale: 1.1, boxShadow: '0 20px 40px rgba(134, 74, 231, 0.3)' }}
              whileTap={{ scale: 0.95 }}
            >
              {currentLanguage === 'en' 
                ? 'Start Your Journey With Us' 
                : 'ابدأ رحلتك معنا'}
            </motion.button>
            
            <motion.button 
              className="contact-now-button"
              onClick={() => navigate('/contact')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {currentLanguage === 'en' ? 'Contact Us Now' : 'تواصل معنا الآن'}
            </motion.button>
          </div>
          
          <div className="contact-info">
            <p>{currentLanguage === 'en' ? 'Contact Us:' : 'تواصل معنا:'}</p>
            <p>📞 +218 927 822 144</p>
            <p>✉️ info@sanad-ins.com</p>
            <p>📍 Tripoli, Libya</p>
          </div>
        </motion.div>
      </StoryScene>
      
      {/* مودال تسجيل الدخول */}
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)} 
      />
      
      {/* فوتر بسيط */}
      <footer className="site-footer">
        <div className="container">
          <p>© 2026 سند للتأمين - SANAD Insurance. {currentLanguage === 'en' ? 'All rights reserved.' : 'جميع الحقوق محفوظة.'}</p>
          <p>{currentLanguage === 'en' ? 'Licensed and regulated by Libyan Insurance Authority' : 'مرخصة ومنظمة من قبل هيئة التأمين الليبية'}</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;


// import React, { useState, useEffect } from 'react';
// import { motion } from 'framer-motion';
// import { useSelector, useDispatch } from 'react-redux';
// import Header from '../components/Header/Header';
// import StoryScene from '../components/StoryScene/StoryScene';
// import InsuranceCard from '../components/InsuranceCard/InsuranceCard';
// import LanguageToggle from '../components/LanguageToggle/LanguageToggle';
// import LoginModal from '../components/LoginModal/LoginModal';
// import { setLanguage } from '../redux/slices/languageSlice';
// import './HomePage.css';
// import { useNavigate } from 'react-router-dom'; // أضف هذا الاستيراد

// const HomePage = () => {
//   const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
//   const [butterflies, setButterflies] = useState([]);
//   const dispatch = useDispatch();
//     const navigate = useNavigate(); // أضف هذا السطر

//   const { currentLanguage } = useSelector((state) => state.language);
//   const { isAuthenticated } = useSelector((state) => state.auth);
  
//   const insuranceTypes = [
//     'Compulsory Car Insurance',
//     'Complementary Car Insurance',
//     'Travelers Insurance',
//     'Aviation Insurance',
//     'Fire Insurance',
//     'Energy Insurance',
//     'Engineering Insurance',
//     'Personal Accident Insurance',
//     'Medical Insurance',
//     'Social Takaful Insurance',
//     'Miscellaneous Accidents (Properties)',
//     'Miscellaneous Accidents (Liabilities)',
//     'Objects Insurance',
//   ];
  
//   useEffect(() => {
//     // إنشاء الفراشات المتحركة
//     const newButterflies = Array.from({ length: 8 }).map((_, i) => ({
//       id: i,
//       x: Math.random() * 100,
//       y: Math.random() * 100,
//       delay: Math.random() * 5,
//       size: Math.random() * 20 + 20,
//     }));
//     setButterflies(newButterflies);
    
//     // تعيين اللغة الافتراضية
//     dispatch(setLanguage('en'));
//   }, [dispatch]);
  

//   const scrollToSection = (sectionId) => {
//   if (sectionId === 'services') {
//     navigate('/services');
//     return;
//   }
//   if (sectionId === 'about') {
//     navigate('/about');
//     return;
//   }
//   if (sectionId === 'contact') {
//     navigate('/contact');
//     return;
//   }
  
//   const element = document.getElementById(sectionId);
//   if (element) {
//     element.scrollIntoView({ behavior: 'smooth' });
//   }
// };


//   const renderButterflies = () => {
//     return butterflies.map((butterfly) => (
//       <motion.div
//         key={butterfly.id}
//         className="butterfly"
//         style={{
//           left: `${butterfly.x}%`,
//           top: `${butterfly.y}%`,
//           width: `${butterfly.size}px`,
//           height: `${butterfly.size}px`,
//         }}
//         animate={{
//           x: [0, 50, 0],
//           y: [0, -50, 0],
//           rotate: [0, 180, 360],
//         }}
//         transition={{
//           duration: 15 + butterfly.delay,
//           repeat: Infinity,
//           ease: "linear",
//         }}
//       />
//     ));
//   };
  
//   return (
//     <div className={`home-page ${currentLanguage === 'ar' ? 'rtl' : 'ltr'}`}>
//       {/* خلفية متحركة */}
//       <div className="animated-bg" />
      
//       {/* الفراشات المتحركة */}
//       {renderButterflies()}
      
//       {/* الهيدر */}
//       <Header />
    
      
//       {/* المشهد الأول: البداية */}
//       <StoryScene 
//         sceneId="home"
//         background="linear-gradient(135deg, rgba(109, 40, 217, 0.9) 0%, rgba(139, 92, 246, 0.8) 100%)"
//         particles={20}
//       >
//         <motion.div
//           initial={{ opacity: 0, y: 50 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 1 }}
//         >
//           <h1 className="scene-title breathing">
//             {currentLanguage === 'en' 
//               ? 'In a world full of surprises…' 
//               : 'في عالم مليان مفاجآت…'}
//           </h1>
//           <p className="scene-subtitle fade-in" style={{ animationDelay: '0.5s' }}>
//             {currentLanguage === 'en' 
//               ? 'Peace of mind is not a luxury' 
//               : 'الاطمئنان مش رفاهية'}
//           </p>
//           <motion.button 
//             className="cta-button pulse-soft"
//             onClick={() => setIsLoginModalOpen(true)}
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//           >
//             {isAuthenticated 
//               ? (currentLanguage === 'en' ? 'Go to Dashboard' : 'الذهاب للوحة التحكم')
//               : (currentLanguage === 'en' ? 'Start Your Journey' : 'ابدأ رحلتك معنا')}
//           </motion.button>

//           <motion.button 
//           className="view-services-btn"
//           onClick={() => scrollToSection('services')}
//           whileHover={{ scale: 1.05 }}
//           whileTap={{ scale: 0.95 }}
//           >
//           {currentLanguage === 'en' ? 'Explore Our Services' : 'اكتشف خدماتنا'}
//         </motion.button>

//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد الثاني: القلق اليومي */}
//       <StoryScene 
//         sceneId="services"
//         background="linear-gradient(135deg, rgb(106, 67, 147) 0%, rgb(126, 69, 233) 100%)"
//         particles={15}
//       >
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <h2 className="scene-title">
//             {currentLanguage === 'en' 
//               ? 'Daily worries that need protection' 
//               : 'هموم يومية تحتاج للحماية'}
//           </h2>
//           <div className="worry-items">
//             <motion.div 
//               className="worry-item"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               viewport={{ once: true }}
//             >
//               <span className="worry-icon">🚗</span>
//               <p>{currentLanguage === 'en' ? 'A simple accident' : 'حادث بسيط'}</p>
//             </motion.div>
//             <motion.div 
//               className="worry-item"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.4 }}
//               viewport={{ once: true }}
//             >
//               <span className="worry-icon">✈️</span>
//               <p>{currentLanguage === 'en' ? 'An unexpected journey' : 'رحلة غير متوقعة'}</p>
//             </motion.div>
//             <motion.div 
//               className="worry-item"
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <span className="worry-icon">🏠</span>
//               <p>{currentLanguage === 'en' ? 'A decision needing security' : 'قرار يحتاج أمان'}</p>
//             </motion.div>
//           </div>
//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد الثالث: ظهور سند */}
//       <StoryScene 
//         sceneId="about"
//         background="linear-gradient(135deg, rgba(124, 58, 237, 0.9) 0%, rgba(167, 139, 250, 0.8) 100%)"
//         particles={10}
//       >
//         <motion.div
//           initial={{ scale: 0 }}
//           whileInView={{ scale: 1 }}
//           transition={{ type: "spring", stiffness: 100, damping: 10 }}
//           viewport={{ once: true }}
//           className="sanad-reveal"
//         >
//           <div className="sanad-logo">
//             <span className="logo-shield">🛡️</span>
//             <h2 className="logo-text">سند</h2>
//             <p className="logo-sub">SANAD Insurance</p>
//           </div>
//           <motion.p 
//             className="reveal-text"
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ duration: 1, delay: 0.5 }}
//             viewport={{ once: true }}
//           >
//             {currentLanguage === 'en' 
//               ? 'And here… there is support' 
//               : 'وهنا… يكون السند'}
//           </motion.p>
//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد الرابع: الخدمات */}
//       <StoryScene 
//         sceneId="services"
//         background="linear-gradient(135deg, rgb(161, 129, 248) 0%, rgb(171, 160, 204) 100%)"
//       >
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <h2 className="scene-title">
//             {currentLanguage === 'en' 
//               ? 'What We Offer' 
//               : 'ماذا نقدم؟'}
//           </h2>
//           <p className="scene-subtitle">
//             {currentLanguage === 'en' 
//               ? 'Because safety should be simple' 
//               : 'لأن الأمان لازم يكون بسيط'}
//           </p>
//           <div className="insurance-grid">
//             {insuranceTypes.map((insurance, index) => (
//               <InsuranceCard 
//                 key={insurance} 
//                 insurance={insurance} 
//                 index={index}
//               />
//             ))}
//           </div>
//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد الخامس: الفلسفة */}
//       <StoryScene 
//         sceneId="philosophy"
//         background="linear-gradient(135deg, rgba(16, 185, 129, 0.9) 0%, rgba(52, 211, 153, 0.8) 100%)"
//       >
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//           className="philosophy-content"
//         >
//           <h2 className="scene-title breathing">
//             {currentLanguage === 'en' 
//               ? 'At Sanad' 
//               : 'في سند'}
//           </h2>
//           <motion.p 
//             className="philosophy-text"
//             initial={{ opacity: 0, y: 20 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.8, delay: 0.3 }}
//             viewport={{ once: true }}
//           >
//             {currentLanguage === 'en' 
//               ? 'We don\'t sell policies, we provide peace of mind' 
//               : 'ما نبيع وثيقة، نقدم راحة بال'}
//           </motion.p>
//           <div className="breathing-circle"></div>
//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد السادس: الثقة */}
//       <StoryScene 
//         sceneId="trust"
//         background="linear-gradient(135deg, rgba(99, 102, 241, 0.9) 0%, rgba(129, 140, 248, 0.8) 100%)"
//       >
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//         >
//           <h2 className="scene-title">
//             {currentLanguage === 'en' 
//               ? 'Trust Built on Clear Service' 
//               : 'ثقة تبنى على خدمة واضحة'}
//           </h2>
//           <div className="trust-stats">
//             <motion.div 
//               className="stat-item"
//               initial={{ opacity: 0, scale: 0 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.5, delay: 0.2 }}
//               viewport={{ once: true }}
//             >
//               <h3 className="stat-number">+15K</h3>
//               <p className="stat-label">
//                 {currentLanguage === 'en' ? 'Protected Clients' : 'عميل محمي'}
//               </p>
//             </motion.div>
//             <motion.div 
//               className="stat-item"
//               initial={{ opacity: 0, scale: 0 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.5, delay: 0.4 }}
//               viewport={{ once: true }}
//             >
//               <h3 className="stat-number">24/7</h3>
//               <p className="stat-label">
//                 {currentLanguage === 'en' ? 'Support Available' : 'دعم متاح'}
//               </p>
//             </motion.div>
//             <motion.div 
//               className="stat-item"
//               initial={{ opacity: 0, scale: 0 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               transition={{ duration: 0.5, delay: 0.6 }}
//               viewport={{ once: true }}
//             >
//               <h3 className="stat-number">13</h3>
//               <p className="stat-label">
//                 {currentLanguage === 'en' ? 'Insurance Types' : 'نوع تأمين'}
//               </p>
//             </motion.div>
//           </div>
//           <p className="trust-text">
//             {currentLanguage === 'en' 
//               ? '(No exaggeration, no big promises)' 
//               : '(بدون مبالغة، بدون وعود كبيرة)'}
//           </p>
//         </motion.div>
//       </StoryScene>
      
//       {/* المشهد الأخير: الدعوة */}
//       <StoryScene 
//         sceneId="contact"
//         background="linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(248, 250, 252, 0.95) 100%)"
//       >
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           transition={{ duration: 1 }}
//           viewport={{ once: true }}
//           className="invitation-content"
//         >
//           <h2 className="scene-title" style={{ color: 'var(--primary-color)' }}>
//             {currentLanguage === 'en' 
//               ? 'Be at peace, Sanad is with you' 
//               : 'خليك مطمئن، وسند معاك'}
//           </h2>
//           <motion.button 
//             className="final-cta-button"
//             onClick={() => setIsLoginModalOpen(true)}
//             whileHover={{ scale: 1.1, boxShadow: '0 20px 40px rgba(109, 40, 217, 0.3)' }}
//             whileTap={{ scale: 0.95 }}
//           >
//             {currentLanguage === 'en' 
//               ? 'Start Your Journey With Us' 
//               : 'ابدأ رحلتك معنا'}
//           </motion.button>
          
     
          
//           <div className="contact-info">
//             <p>{currentLanguage === 'en' ? 'Contact Us:' : 'تواصل معنا:'}</p>
//             <p>📞 +218 21 123 4567</p>
//             <p>✉️ info@sanad-ins.com</p>
//             <p>📍 Tripoli, Libya</p>
//           </div>
//         </motion.div>
//       </StoryScene>
      
//       {/* مودال تسجيل الدخول */}
//       <LoginModal 
//         isOpen={isLoginModalOpen} 
//         onClose={() => setIsLoginModalOpen(false)} 
//       />
      
//       {/* فوتر بسيط */}
//       <footer className="site-footer">
//         <div className="container">
//           <p>© 2024 سند للتأمين - SANAD Insurance. {currentLanguage === 'en' ? 'All rights reserved.' : 'جميع الحقوق محفوظة.'}</p>
//           <p>{currentLanguage === 'en' ? 'Licensed and regulated by Libyan Insurance Authority' : 'مرخصة ومنظمة من قبل هيئة التأمين الليبية'}</p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default HomePage;